import type { NavSection } from '@/shared/components/AppShell/nav-section'

export type AppShellHeaderSearchConfig = {
  show: boolean
  placeholder: string
  testId: string
  ariaLabel: string
  section: 'library' | 'campaigns' | 'sensemakers' | 'signalProviders' | null
}

type ResolveArgs = Readonly<{
  activeSection: NavSection | null
  pathname: string
  showAppShellBack: boolean
  showAppShellInstrumentTitle: boolean
  /** @deprecated Campaign search moved inline on Research page (BFP-999). */
  hasCampaigns?: boolean
}>

const HIDDEN: AppShellHeaderSearchConfig = {
  show: false,
  placeholder: '',
  testId: 'app-shell-header-search',
  ariaLabel: '',
  section: null,
}

export function resolveAppShellHeaderSearch({
  activeSection,
  pathname,
  showAppShellBack,
  showAppShellInstrumentTitle,
}: ResolveArgs): AppShellHeaderSearchConfig {
  if (showAppShellBack || showAppShellInstrumentTitle) {
    return HIDDEN
  }

  if (activeSection === 'library') {
    return HIDDEN
  }

  // BFP-999 — campaign search lives inline on the Campaigns tab (same layout as Direct
  // Instrument Building), not in the AppShell header.
  if (activeSection === 'campaigns') {
    return HIDDEN
  }

  if (activeSection === 'tenants' && pathname === '/tenants') {
    return {
      show: true,
      placeholder: 'Search by Sensemaker',
      testId: 'app-shell-sensemaker-search',
      ariaLabel: 'Search by Sensemaker',
      section: 'sensemakers',
    }
  }

  if (activeSection === 'signalProviders' && pathname === '/signal-providers') {
    return {
      show: true,
      placeholder: 'Search by name, Phone, email, or SP ID',
      testId: 'app-shell-signal-provider-search',
      ariaLabel: 'Search signal providers',
      section: 'signalProviders',
    }
  }

  return HIDDEN
}
